import React from 'react'
import { FaTwitch, FaYoutube } from 'react-icons/fa'
import { SiBluesky } from 'react-icons/si'
import './Footer.css'

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-title">Lazy Load Studios</h3>
            <p className="footer-description">
              Creating innovative gaming experiences that push the boundaries of interactive entertainment.
            </p>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-heading">Studio</h4>
            <ul className="footer-links">
              <li><a href="#about">About Us</a></li>
              <li><a href="#projects">Our Projects</a></li>
              <li><a href="https://demortes.dev">News & Updates</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-heading">Connect</h4>
            <ul className="footer-links">
              <li><a href="mailto:webmaster@lazy-load.com">Contact</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-heading">Stay Updated</h4>
            <p className="footer-text">
              Follow our journey as we develop exciting new games and experiences.
            </p>
            <div className="footer-social-icons">
              <a href="https://www.youtube.com/@lazyloadstudios" aria-label="YouTube"><FaYoutube /></a>
              <a href="https://www.twitch.tv/lazyloadstudios" aria-label="Twitch"><FaTwitch /></a>
              <a href="https://bsky.app/profile/lazyloadstudios.bsky.social" aria-label="Bluesky"><SiBluesky /></a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p className="footer-copyright">
            © 2025 Lazy Load Studios. All rights reserved. | Led by Demortes
          </p>
          <div className="footer-legal">
            <a href="/terms-of-service.html">Terms of Service</a>
            <span className="separator">|</span>
            <a href="/privacy-policy.html">Privacy Policy</a>
          </div>
          <div className="footer-status">
            <span className="status-indicator"></span>
            Currently developing amazing games
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer